import React, { useState } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { upperCaseFirstLetter } from 'common/utils/utils';
import Switch from 'common/components/elements/inputs/switch';
import CheckBox from 'common/components/elements/inputs/checkbox';
import Button from 'common/components/elements/buttons/primary';
import {
   getGlobalSettings,
   DESIGN_IMAGE_AWS_PATH,
   DESIGN_VIDEO_AWS_PATH,
   // DEFAULT_ACCESS,
} from 'admin/views/site-designer/data';
import ImageUploader from 'admin/views/promotions/modules/image-uploader';
import { getObjectUrl, uploadDesignImage, getS3Policy } from 'admin/api/AuthApi';
import axios from 'axios';
import randomstring from 'randomstring';

const WrraperFrame = ({
   children,
   isHasBg = true,
}) => {
   return (
      // <div className='flex flex-col bg-grey-main rounded-lg p-3 gap-4'>
      <div
         className={ cx({
            'flex flex-col gap-4': true,
            'bg-grey-main rounded-lg p-3': isHasBg,
         }) }
      >
         {
            children && children
         }
      </div>
   )
}

const SectionFrame = ({
   children,
   title,
   description,
   rightComponent,
   isOptional,
   isPanelBg,
}) => {
   return (
      <div
         className={ cx({
            'flex flex-col gap-4': true,
            'bg-panel rounded-lg p-3': isPanelBg,
         }) }
      >
         {
            Boolean(description || title) && (
               <div className='flex justify-between'>
                  <div className='flex flex-col gap-1'>
                     <span className='text-base font-medium leading-[20px] text-major'>{title}
                        {isOptional && <span className='text-xs text-secondary leading-[20px]'>&nbsp;(Optional)</span>}
                     </span>
                     {
                        Boolean(description) && (
                           <span className='text-[13px] leading-[16px] text-secondary'>{description}</span>
                        )
                     }
                  </div>
                  {rightComponent && (
                     rightComponent
                  )
                  }
               </div>
            )
         }
         {
            children && children
         }
      </div>
   )
}

const OptionLableWrapper = ({
   isSelected,
   title,
   children,
   onClick,
}) => {
   return (
      <div
         role='presentation'
         onClick={ onClick }
         className={ cx({
            'flex items-center justify-center rounded-lg h-18 flex-1 bg-panel cursor-pointer': true,
            'border-2 border-action': isSelected,
            'border border-divider': !isSelected,
         }) }
      >
         <div className='flex flex-col gap-[6px] items-center w-full'>
            {children && children}
            {
               title && (
                  <span className='text-major text-xs leading-[15px]'>{upperCaseFirstLetter(title)}</span>
               )
            }
         </div>
      </div>
   )
}
const RightChekComponent = ({
   rightComponent,
   checked,
   onChange,
   name,
}) => {
   if('switch' === rightComponent){
      return (
         <Switch
            name={ name }
            checked={ checked }
            onChange={ onChange }
         />
      )
   }
   return (
      <CheckBox
         name={ name }
         isChecked={ checked }
         onChange={ onChange }
      />
   )
}
const GoToGlobalSettingsButton = ({
   state,
   onChangeSegment,
}) => {
   return (
      <div className='mx-auto h-9 items-center mt-2'>
         <Button
            text={ state.text }
            textSize='small'
            primaryColor
            iconName='go-to'
            backgroundColor='transparent'
            padding='none'
            onClick={ () => {
               const settings = getGlobalSettings();
               const item = settings.find(setting => setting.uuid === state.type);
               onChangeSegment(item, state.segment_type)
            } }
            classNames='h-full'
            textMarginExistSecondIcon='0'
         />
      </div>
   )
}

const SiteDesignFileUpload = ({
   src,
   fullSrc,
   onChange,
   uploadImageText,
   type = 'image',
}) => {

   const isMobile = false;
   const [fileUploaderState, setFileUploaderState] = useState({
      src: src,
      full_src: fullSrc,
      error: '',
      loading: false,
   })

   const uploadIdentificationVideo = async (file, src) => {
      try {
         const client = axios.create();
         const basename = randomstring.generate(32);
         const filename = `${ basename }.mp4`;
         const s3PolicyGet = await getS3Policy();
         const s3Policy = s3PolicyGet.data;
         const key = `${ DESIGN_VIDEO_AWS_PATH }${ filename }`;
         const formData = new FormData();
         formData.append('key', key);
         formData.append('AWSAccessKeyId', s3Policy.accesskey);
         formData.append('acl', 'private');
         formData.append('success_action_status', '201');
         formData.append('policy', s3Policy.policy);
         formData.append('signature', s3Policy.signature);
         formData.append('file', file);
         client.post(
            `https://${ s3Policy.bucket }.s3.amazonaws.com`,
            formData,
            {
               headers: {
                  'Content-Type': 'multipart/form-data',
               },
            }
         );
         const path = filename;
         return Promise.resolve({
            path,
            fullPath: src,
         });
      } catch (error) {
         return Promise.reject(error);
      }
   }

   const toBase64 = file => new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = reject;
   });
   const uploadIdentificationImage = async (file) => {
      try {
         const data = new FormData();
         data.append('file', file);
         const { data: { path } } =  await uploadDesignImage(data);
         const result =  await getObjectUrl([path], DESIGN_IMAGE_AWS_PATH);
         return Promise.resolve({
            path,
            fullPath: result?.data?.[path],
         });
      } catch (error) {
         return Promise.reject(error);
      }
   }
   const handleFileChange = async (file) => {

      // const type = file.name.split('.');
      // const validFormat = ['png', 'jpeg', 'jpg'];
      // const isValid = validFormat.indexOf(type[type.length - 1].toLowerCase()) !== -1 && type.length > 1;
      // if(!isValid) {
      //    // not valid type
      //    setFileUploaderState({
      //       ...fileUploaderState,
      //       [fileType]: {
      //          full_src: '',
      //          src: '',
      //          error: 'Invalid format',
      //          loading: false,
      //       },
      //    });
      //    return;
      // }
      setFileUploaderState({
         ...fileUploaderState,
         full_src: '',
         src: '',
         error: '',
         loading: true,
      });

      let path = null;
      let fullPath = null;
      try {
         if('video' === type) {
            const targetSrc = await toBase64(file)
            const data = await uploadIdentificationVideo(file, targetSrc);
            path = data.path;
            fullPath = data.fullPath;
         } else {
            // const formData = new FormData()
            // formData.append('file', file)
            const data = await uploadIdentificationImage(file);
            path = data.path;
            fullPath = data.fullPath;
         }
         setFileUploaderState({
            ...fileUploaderState,
            error: '',
            loading: false,
            full_src: fullPath,
            src: path,
         });
         onChange(path, fullPath);
      } catch (error) {
         setFileUploaderState({
            ...fileUploaderState,
            error: error?.message || 'Error',
            loading: false,
            full_src: '',
            src: '',
         });
      }

   }

   return (
      <ImageUploader
         // screenWidth={ screenWidth }
         isMobile={ isMobile }
         handleChangeImage={ (file) => handleFileChange(file) }
         accept={ 'image' === type ? 'image/png,image/jpeg' : 'video/*' }
         source={ fileUploaderState?.full_src  }
         loading={ fileUploaderState?.loading  }
         errorMessage={ fileUploaderState?.error  }
         handleDeleteImage={ () =>   {
            setFileUploaderState({
               error: null,
               loading: false,
               full_src: '',
               src: '',
            });
            onChange(null)
         } }
         uploadImageText={ uploadImageText }
         height='!h-full'
      />
   );
};


WrraperFrame.propTypes = {
   children: PropTypes.any,
   isHasBg: PropTypes.bool,
};
SectionFrame.propTypes = {
   children: PropTypes.any,
   title: PropTypes.string,
   description: PropTypes.string,
   rightComponent: PropTypes.any,
   isOptional: PropTypes.bool,
   isPanelBg: PropTypes.bool,
};
OptionLableWrapper.propTypes = {
   isSelected: PropTypes.bool,
   title: PropTypes.string,
   children: PropTypes.any,
   onClick: PropTypes.func,
};
RightChekComponent.propTypes = {
   rightComponent: PropTypes.string,
   checked: PropTypes.any,
   onChange: PropTypes.func,
   name: PropTypes.string,
};

GoToGlobalSettingsButton.propTypes = {
   state: PropTypes.object,
   onChangeSegment: PropTypes.func,
};
SiteDesignFileUpload.propTypes = {
   uploadImageText: PropTypes.string,
   fullSrc: PropTypes.string,
   src: PropTypes.string,
   onChange: PropTypes.func,
   type: PropTypes.string,
};


export {
   WrraperFrame,
   SectionFrame,
   OptionLableWrapper,
   RightChekComponent,
   GoToGlobalSettingsButton,
   SiteDesignFileUpload,
};
